import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type { StoreProductRequest, StoreProductResponse } from '@/types/storeProduct';

export const storeProductsApi = {
  list: (params?: SearchParams & { storeId?: number }) =>
    unwrap(api.get<ApiResponse<PageResponse<StoreProductResponse>>>('/v1/store-products', { params })),

  listByStore: (storeId: number) =>
    unwrap(api.get<ApiResponse<StoreProductResponse[]>>(`/v1/store-products/by-store/${storeId}`)),

  get: (id: number) => unwrap(api.get<ApiResponse<StoreProductResponse>>(`/v1/store-products/${id}`)),

  create: (body: StoreProductRequest) =>
    unwrap(api.post<ApiResponse<StoreProductResponse>>('/v1/store-products', body)),

  update: (id: number, body: StoreProductRequest) =>
    unwrap(api.put<ApiResponse<StoreProductResponse>>(`/v1/store-products/${id}`, body)),

  delete: (id: number) => unwrap(api.delete<ApiResponse<null>>(`/v1/store-products/${id}`)),

  activate: (id: number, active: boolean) =>
    unwrap(
      api.patch<ApiResponse<StoreProductResponse>>(`/v1/store-products/${id}/activate`, null, {
        params: { active },
      }),
    ),
};
